<template>
  <div
    class="tv-detail-page"
    :class="{isEnglish: $isEnglish, isChinese: !$isEnglish}"
  >
    <a-breadcrumb
      class="m-t-16"
    >
      <a-breadcrumb-item>
        <router-link
          :to="{
            name: 'configIndex',
            params: {
              pid
            }
          }"
        >
          {{ $t('message["1326"]') }}
        </router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item
        class="breadcrumb-item fs-blue btn"
        @click.native="goBack"
      >
        {{ $t('message["1783"]') }}
      </a-breadcrumb-item>
      <a-breadcrumb-item>{{ id ? $t('message[1790]') : $t('message[1789]') }}</a-breadcrumb-item>
    </a-breadcrumb>
    <h1 class="title">
      {{ id ? $t('message[1790]') : $t('message[1789]') }}
    </h1>

    <a-form
      :form="form"
    >
      <!-- 大屏名称 -->
      <a-form-item
        :label="$t('message[1792]')"
        class="name-input"
      >
        <a-input
          v-decorator="['name', {
            rules: [{ required: true, validator: validateRepeat }],
            initialValue: detail.name
          }]"
          maxlength="8"
          :placeholder="$t('message[751]')"
          @change="handleInput($event, 'name')"
        />
        <span
          v-if="detail.name"
          class="num"
        >{{ detail.name.length }}/8</span>
      </a-form-item>
      <!-- 屏幕布局 -->
      <a-form-item
        :label="$t('message[1793]')"
      >
        <a-select
          v-decorator="['type', {
            rules: [{
              required: true, message: $t('message[855]')
            }],
            initialValue: detail.type
          }]"
          :placeholder="$t('message[855]')"
          @change="handleChangeType"
        >
          <a-select-option
            v-for="option in layoutTypeOptions"
            :key="option.id"
            :value="option.id * 1"
          >
            {{ option.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <!-- 团队 -->
      <div
        v-for="(itemData, index) in detail.range"
        :key="index"
        class="group-box"
      >
        <h3
          v-if="detail.type !== 8"
          class="title"
        >
          {{ $t('message[1824]') }}{{ index + 1 }}
        </h3>
        <!-- 团队名称 -->
        <a-form-item
          v-if="detail.type !== 8"
          :label="$t('message[1941]')"
          class="name-input"
        >
          <div
            v-decorator="[`group.${index}.team`, {
              rules: [{ required: true, message: $t('message[751]') }],
              initialValue: itemData.team
            }]"
          >
            <a-input
              v-model="itemData.team"
              maxlength="8"
              :placeholder="$t('message[751]')"
              @change="handleInputItem($event, 'team', index)"
            />
            <span
              v-if="itemData.team"
              class="num"
            >{{ itemData.team.length }}/8</span>
          </div>
        </a-form-item>
        <!-- 数据类型 -->
        <a-form-item :label="$t('message[1942]')">
          <div
            v-decorator="[`group.${index}.rangetype`, {
              rules: [{
                required: true, message: $t('message[855]')
              }],
              initialValue: detail.range[index].type
            }]"
          >
            <a-select
              v-model="detail.range[index].type"
              :placeholder="$t('message[855]')"
              @change="handleChangeRangeType($event, index)"
            >
              <a-select-option
                v-for="option in rangeTypeOptions"
                :key="option.key"
                :value="option.key"
              >
                {{ option.name }}
              </a-select-option>
            </a-select>
            <!-- 有效询盘/成交金额 -->
            <span
              v-if="itemData.type"
              class="m-l-16 fs-gray fz-12"
            >{{ itemData.type !=='follow' ? $t('message[1969]') : $t('message[1970]') }}</span>
          </div>
        </a-form-item>
        <!-- 数据范围 -->
        <a-form-item
          v-if="itemData.type"
          :label="$t('message[1794]')"
          :required="true"
        >
          <!-- 设置 -->
          <a
            v-if="!itemData.data.length"
            @click="handleEditRange(index, itemData.type)"
          >{{ $t('message[1008]') }}</a>
          <template v-else>
            <div>
              <span
                v-for="(member, i) in itemData.data"
                :key="i"
                class="member"
                :class="{ lastMember: i === itemData.data.length - 1 }"
              >
                <template v-if="member.truename">{{ member.truename }}{{ i === 0 && itemData.data.length === 1 ? '' : ';' }}</template>
                <template v-else-if="member.groupname">{{ member.groupname }}{{ i === 0 && itemData.data.length === 1 ? '' : ';' }}</template>
                <template v-else-if="member.rolename">{{ member.rolename }}{{ i === 0 && itemData.data.length === 1 ? '' : ';' }}</template>
              </span>
              <!-- 修改 -->
              <a
                class="edit-range-btn m-l-8"
                @click="handleEditRange(index, itemData.type)"
              >{{ $t('message[1388]') }}</a>
            </div>
          </template>
          <div
            v-decorator="[`group.${index}.range`, {
              rules: [{
                required: true, type: 'array', message: $t('message[855]')
              }],
              initialValue: itemData.data
            }]"
            class="hide"
          >
            <a-checkbox-group
              v-model="itemData.data"
            />
          </div>
        </a-form-item>
        <!-- 目标 -->
        <a-form-item
          v-if="itemData.type && detail.target[index]"
          :label="$t('message[1795]')"
        >
          <div
            v-decorator="[`group.${index}.unit`, {
              rules: [{
                required: true, message: $t('message[855]')
              }],
              initialValue: detail.target[index].unit
            }]"
          >
            <a-radio-group
              v-model="detail.target[index].unit"
              :options="unitOptions"
              class="target-radio"
              @change="onChangeTarget($event, index)"
            />
          </div>
        </a-form-item>
        <template v-if="itemData.type && detail.target[index] && detail.target[index].unit !== 0 && itemData.type !== 'follow'">
          <!-- 目标类型 -->
          <a-form-item
            :label="$t('message[1943]')"
          >
            <div
              v-decorator="[`group.${index}.target.type`, {
                rules: [{
                  required: true, message: $t('message[855]')
                }],
                initialValue: detail.target[index].type
              }]"
            >
              <a-radio-group
                v-model="detail.target[index].type"
                :options="unitTypeOptions"
                class="target-radio"
                @change="onChangeTargetType($event, index)"
              />
            </div>
          </a-form-item>
          <!-- 等级 -->
          <ul
            v-if="detail.target[index].type === 1"
            class="level-box clearfix"
          >
            <li class="fl">
              <!-- 总体 -->
              <span class="tit">{{ $t('message[1944]') }}({{ $t('message[1199]') }})</span>
              <a-form-item>
                <div
                  v-decorator="[`group.${index}.total.level`, {
                    rules: [{
                      validator: checkInputNumber
                    }],
                    initialValue: detail.target[index].data.total
                  }]"
                >
                  <a-input-number
                    v-model="detail.target[index].data.total"
                    :min="0"
                    :max="1000000000"
                    :formatter="value => formatterValue(value)"
                    @change="handleChangeTotal($event, index)"
                  />
                </div>
              </a-form-item>
            </li>
            <li
              v-for="(levelItem, i) in detail.target[index].data.levels"
              :key="levelItem && levelItem.id"
              class="fl"
            >
              <span class="tit">{{ levelItem.name }}({{ $t('message[1199]') }})</span>
              <a-form-item>
                <a-input-number
                  v-model="levelItem.value"
                  :min="0"
                  :max="1000000000"
                  :formatter="value => formatterValue(value)"
                  @change="handleInputLevel($event, index, i)"
                />
              </a-form-item>
            </li>
          </ul>
          <!-- 按基础值/目标值/挑战值设置 -->
          <!-- 总体目标 -->
          <a-form-item
            v-if="detail.target[index] && detail.target[index].type === 2"
            :label="$t('message[1945]')"
            :required="true"
            class="overall-goals-item"
          >
            <!-- 基础值 -->
            <a-form-item
              :label="$t('message[1946]')"
              class="target-input"
            >
              <div
                v-decorator="[`group.${index}.total.base`, {
                  rules: [{
                    validator: checkInputNumber
                  }],
                  initialValue: detail.target[index].base
                }]"
              >
                <a-input-number
                  v-model="detail.target[index].base"
                  :placeholder="$t('message[751]')"
                  :min="0"
                  :max="1000000000"
                  :formatter="value => formatterValue(value)"
                  @change="handleChangeNumber($event, index, 'base')"
                  @blur="handleBlurTarget($event, index, 'base')"
                />
                <span class="txt">{{ $t('message[1713]') }}</span>
              </div>
            </a-form-item>
            <!-- 目标值 -->
            <a-form-item
              :label="$t('message[1947]')"
              class="target-input"
            >
              <div
                v-decorator="[`group.${index}.total.target`, {
                  rules: [{
                    validator: checkInputNumber
                  }],
                  initialValue: detail.target[index].target
                }]"
              >
                <a-input-number
                  v-model="detail.target[index].target"
                  :placeholder="$t('message[751]')"
                  :min="0"
                  :max="1000000000"
                  :formatter="value => formatterValue(value)"
                  @change="handleChangeNumber($event, index, 'target')"
                  @blur="handleBlurTarget($event, index, 'target')"
                />
                <span class="txt">{{ $t('message[1713]') }}</span>
              </div>
            </a-form-item>
            <!-- 挑战值 -->
            <a-form-item
              :label="$t('message[1948]')"
              class="target-input"
            >
              <div
                v-decorator="[`group.${index}.total.challenge`, {
                  rules: [{
                    validator: checkInputNumber
                  }],
                  initialValue: detail.target[index].challenge
                }]"
              >
                <a-input-number
                  v-model="detail.target[index].challenge"
                  :placeholder="$t('message[751]')"
                  :min="0"
                  :max="1000000000"
                  :formatter="value => formatterValue(value)"
                  @change="handleChangeNumber($event, index, 'challenge')"
                  @blur="handleBlurTarget($event, index, 'challenge')"
                />
                <span class="txt">{{ $t('message[1713]') }}</span>
              </div>
            </a-form-item>
          </a-form-item>
          <!-- 分解目标 -->
          <a-form-item
            v-if="detail.target[index] && detail.target[index].type === 2 && itemData.data && itemData.data.length"
            :label="$t('message[1949]')"
            class="target-child-wrap"
          >
            <ul class="target-child">
              <li
                class="tit"
              >
                <!-- 开发人员 -->
                <span v-if="itemData.type==='dev'">{{ $t('message[549]') }}</span>
                <!-- 接待人员 -->
                <span v-if="itemData.type==='rec'">{{ $t('message[1950]') }}</span>
              </li>
              <!-- 基础值 -->
              <li
                class="tit"
              >
                {{ $t('message[1946]') }}
              </li>
              <!-- 目标值 -->
              <li
                class="tit"
              >
                {{ $t('message[1947]') }}
              </li>
              <!-- 挑战值 -->
              <li
                class="tit"
              >
                {{ $t('message[1948]') }}
              </li>
              <!--  操作 -->
              <li
                class="tit"
              >
                {{ $t('message[79]') }}
              </li>
            </ul>
            <ul
              v-for="(one, k) in detail.target[index].data.info"
              :key="k"
              class="target-child"
            >
              <li class="fl">
                <a-form-item>
                  <div
                    v-decorator="[`group.${index}.userid.${k}`, {
                      rules: [{
                        required: true, message: $t('message[855]')
                      }],
                      initialValue: one.userid
                    }]"
                  >
                    <a-select
                      v-model="one.userid"
                      :placeholder="$t('message[855]')"
                      style="width: 240px"
                      @dropdownVisibleChange="handleVisibleUser($event, index, k)"
                      @change="handleChangeUser($event, index ,k)"
                    >
                      <a-select-option
                        v-for="option in detail.target[index].data.userOptions || []"
                        :key="option.id"
                        :value="option.id"
                      >
                        {{ option.name }}
                      </a-select-option>
                    </a-select>
                  </div>
                </a-form-item>
              </li>
              <li>
                <a-form-item>
                  <div
                    v-decorator="[`group.${index}.child.${k}.base`, {
                      rules: [{
                        validator: checkInputNumber
                      }],
                      initialValue: one.base
                    }]"
                    class="target-input"
                  >
                    <a-input-number
                      v-model="one.base"
                      :placeholder="$t('message[751]')"
                      :min="0"
                      :max="1000000000"
                      :formatter="value => formatterValue(value)"
                      @change="handleChangeChildNumber($event, index, k, 'base')"
                      @blur="handleBlurTargetChild($event, index, k, 'base')"
                    />
                    <span class="txt">{{ $t('message[1713]') }}</span>
                  </div>
                </a-form-item>
              </li>
              <li>
                <a-form-item>
                  <div
                    v-decorator="[`group.${index}.child.${k}.target`, {
                      rules: [{
                        validator: checkInputNumber
                      }],
                      initialValue: one.target
                    }]"
                    class="target-input"
                  >
                    <a-input-number
                      v-model="one.target"
                      :placeholder="$t('message[751]')"
                      :min="0"
                      :max="1000000000"
                      :formatter="value => formatterValue(value)"
                      @change="handleChangeChildNumber($event, index, k, 'target')"
                      @blur="handleBlurTargetChild($event, index, k, 'target')"
                    />
                    <span class="txt">{{ $t('message[1713]') }}</span>
                  </div>
                </a-form-item>
              </li>
              <li>
                <a-form-item>
                  <div
                    v-decorator="[`group.${index}.child.${k}.challenge`, {
                      rules: [{
                        validator: checkInputNumber
                      }],
                      initialValue: one.challenge
                    }]"
                    class="target-input"
                  >
                    <a-input-number
                      v-model="one.challenge"
                      :placeholder="$t('message[751]')"
                      :min="0"
                      :max="1000000000"
                      :formatter="value => formatterValue(value)"
                      @change="handleChangeChildNumber($event, index, k, 'challenge')"
                      @blur="handleBlurTargetChild($event, index, k, 'challenge')"
                    />
                    <span class="txt">{{ $t('message[1713]') }}</span>
                  </div>
                </a-form-item>
              </li>
              <li>
                <!-- 删除 -->
                <a @click="handleDeleteTargetChild(index, k)">{{ $t('message[962]') }}</a>
              </li>
            </ul>
            <!-- 添加 -->
            <a @click="handleAddTargetChild(index)">{{ $t('message[1190]') }}</a>
          </a-form-item>
        </template>
        <!-- 目标值 -->
        <a-form-item
          v-if="itemData.type === 'follow' && detail.target[index] && detail.target[index].unit !== 0"
          :label="$t('message[1947]')"
          class="follow-target-input"
        >
          <div
            v-decorator="[`group.${index}.follow.total`, {
              rules: [{
                required: true,
                validator: checkInputNumber
              }],
              initialValue: detail.target[index].data.total
            }]"
          >
            <a-input-number
              v-model="detail.target[index].data.total"
              :placeholder="$t('message[751]')"
              :min="0"
              :max="1000000000"
              :formatter="value => formatterValue(value)"
              @change="handleChangeNumber($event, index, 'follow')"
              @blur="handleBlurTarget($event, index, 'follow')"
            />
            <!-- 元 -->
            <span class="txt">{{ $t('message[1971]') }} </span>
          </div>
        </a-form-item>
      </div>
    </a-form>
    <!-- 保存按钮 -->
    <div
      class="footer-wrap"
    >
      <div

        ref="footer"
        class="footer"
      >
        <a-button
          type="primary"
          @click="handleSubmit"
        >
          {{ $t('message[21]') }}
        </a-button>
        <a-button
          @click="handlePrivew"
        >
          {{ $t('message[1791]') }}
        </a-button>
      </div>
    </div>
    <code-modal
      :visible.sync="showCodeModal"
      :preview-code="previewCode"
      :title="$t('message[23]')"
    />
    <range-modal
      ref="rangeModal"
      :current-range-datas="rangeData"
      :datas="selectRangeDatas"
      @confirm="changeRangeDatas"
    />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { setFooterStyle } from '@/lib/utils'
import { cloneDeep } from 'lodash'
import { getMyAuthTeamInfo } from '@/services/index'
import { checkRepeat } from '@/services/configTv'
import CodeModal from './CodeModal'
import RangeModal from './RangeDataDialog'

export default {
  components: {
    CodeModal,
    RangeModal
  },
  props: {
    id: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      unitOptions: [{
        value: 1,
        label: this.$t('message[1796]') // '月目标'
      }, {
        value: 2,
        label: this.$t('message[1797]') // '年目标'
      }, {
        value: 3,
        label: this.$t('message[1951]') // '周目标'
      }
      /* , {
        value: 0,
        label: this.$t('message[1798]') // '不设置'
      } */
      ],
      unitTypeOptions: [{
        value: 1,
        label: this.$t('message[1952]') // 按信息分级设置
      }, {
        value: 2,
        label: this.$t('message[1953]') // 按基础值/目标值/挑战值设置
      }],
      form: this.$form.createForm(this),
      detail: {},
      isBtnDisable: false,
      previewHref: '',
      showCodeModal: false,
      rangeData: [],
      selectRangeDatas: [],
      editRangeType: '',
      previewCode: '',
      isGetUserOption: false
    }
  },

  computed: {
    ...mapState('config/tv', ['allConfig', 'layoutTypeOptions', 'formData', 'rangeTypeOptions']),
    pid () {
      return this.$store.state.pid
    },
    levelList () {
      let { level = {} } = this.allConfig || {}
      return Object.values(level)
    },
    typeMap () {
      let obj = {}
      for (let item of this.layoutTypeOptions) {
        obj[item.id] = item.name
      }
      return obj
    }
  },
  watch: {
    formData: {
      handler (val) {
        this.setDetail(val)
      }
      // immediate: true
    },
    allConfig: {
      handler (val) {
        if (val && this.formData) {
          this.setDetail(this.formData)
        }
      }
      // immediate: true
    }
  },
  created () {
    this.fetchAllConfig()
  },
  async mounted () {
    if (this.id) {
      let chain = await this.fetchDetail({ id: this.id })
      chain.onSuccess(res => {
        this.setDetail(this.formData)

        // this.setDisabledBtn(this.formData)
      })
    } else {
      this.detail = {
        type: undefined,
        name: '',
        range: [],
        target: []
      }
    }

    setFooterStyle(this)
    window.addEventListener('resize', () => {
      setFooterStyle(this)
    })
    document.addEventListener('scroll', () => {
      setFooterStyle(this)
    })
  },
  destroyed () {
    let formData = {
      type: undefined,
      name: '',
      range: [],
      target: []
    }
    this.SET_DETAIL(formData)
  },

  methods: {
    ...mapActions('config/tv', ['fetchAllConfig', 'fetchDetail', 'setConfig', 'getAllUselList']),
    ...mapMutations('config/tv', ['SET_DETAIL']),
    goBack () {
      this.$router.push({
        name: 'configTvList'
      })
      this.detail = {
        type: undefined,
        name: '',
        range: [],
        target: []
      }
    },
    async setDetail (detail = {}) {
      let { allConfig = {} } = this
      let { target = [], range = [] } = detail
      let { level: levelMap = {} } = allConfig || {}
      if (!target.length) return

      for (let index in target) {
        const { type: rangeType } = range[index] || {}
        let item = target[index] || {}
        let { data = {}, unit } = item
        if (unit === 0) {
          item.unit = ''
        }
        if (this.$toType(data) === 'array') {
          item.data = {}
          if (rangeType === 'follow') {
            item.data.total = ''
          }
        }
        if (item.type === 1) { // 按信息分级设置
          let { info: levelInfo = {} } = data
          item.data.levels = []
          for (let id in levelMap) {
            let obj = {
              ...levelMap[id],
              value: 0
            }
            for (let levelId in levelInfo) {
              if (id === levelId) {
                obj.value = levelInfo[levelId]
              }
            }
            item.data.levels.push(obj)
          }
        } else if (item.type === 2) { // 按基础值/目标值/挑战值设置
          const { info = [] } = item.data || {}
          if (!this.isGetUserOption && (rangeType === 'dev' || rangeType === 'rec') && info.length) {
            let chain = await this.getAllUselList({
              type: rangeType,
              data: detail.range[index].data
            })
            chain.onSuccess((payload = []) => {
              // TODO:需要改成每行单独的userOptions，后面优化
              // let options = this.resetUserOptions(index, payload)
              this.$set(detail.target[index].data, 'userOptions', payload)
              this.isGetUserOption = true
              this.detail = cloneDeep(detail)
            })
          }
        }
      }
      this.detail = cloneDeep(detail)
    },
    handleInput (e, name) {
      let val = e.target.value
      this.detail[name] = val
      // this.setDisabledBtn(this.detail)
    },
    /* 屏幕布局  */
    async handleChangeType (val) {
      this.detail.type = val
      this.detail.range = []
      this.detail.target = []

      if (val === 8) { // 一列
        this.detail.range.push({
          team: '',
          type: undefined,
          data: []
        })
        this.detail.target.push({
          type: '',
          unit: '',
          data: {}
        })
      } else if (val === 9) { // 两列
        this.detail.range.push({
          team: '',
          type: undefined,
          data: []
        }, {
          team: '',
          type: undefined,
          data: []
        })
        this.detail.target.push({
          type: '',
          unit: '',
          data: {}
        }, {
          type: '',
          unit: '',
          data: {}
        })
      } else if (val === 10) { // 三列
        this.detail.range.push({
          team: '',
          type: undefined,
          data: []
        }, {
          team: '',
          type: undefined,
          data: []
        }, {
          team: '',
          type: undefined,
          data: []
        })
        this.detail.target.push({
          type: '',
          unit: '',
          data: {}
        }, {
          type: '',
          unit: '',
          data: {}
        }, {
          type: '',
          unit: '',
          data: {}
        })
      }

      this.form.resetFields()
      setFooterStyle(this)
    },
    handleInputItem (e, name, index) {
      let val = e.target.value
      this.detail.range[index][name] = val
    },
    async validateRepeat (rule, value = '', callback) {
      let fieldvalue = value.toString()

      if (fieldvalue.trim() === '') {
        const msg = this.$t('message[751]')
        callback(msg)
      } else {
        let res = await checkRepeat()
          .params({
            id: this.id,
            type: 1,
            name: fieldvalue
          })
          .config({ tip: false, warn: false })
          .fetch()

        const { payload = {} } = res && res.data
        const { isrepeat = 0 } = payload

        if (isrepeat === 1) {
          // 已存在同名大屏
          const msg = this.$t('message[1940]')
          callback(msg)
        } else {
          callback()
        }
      }
    },
    /* 数据类型 */
    handleChangeRangeType (val, index) {
      this.detail.range[index]['type'] = val
      this.detail.range[index].data = []

      this.form.setFieldsValue({
        [`group.${index}.rangetype`]: val,
        [`group.${index}.range`]: []
      })

      const { type } = this.detail.range[index]
      const { data = {} } = this.detail.target[index]
      if (type === 'follow' && (data.total === '' || data.total === undefined)) {
        this.$nextTick(() => {
          this.form.setFieldsValue({
            [`group.${index}.follow.total`]: ''
          })
        })
      }
    },
    async getMembers (type) {
      let params = {}
      if (type === 'follow') {
        params.pk = 'inquiry-followup'
      } else if (type === 'dev') {
        params.pk = 'inquiry-dev'
      } else if (type === 'rec') {
        params.pk = 'inquiry-add'
      }

      let chain = await getMyAuthTeamInfo()
      await chain
        .params(params)
        .onSuccess(payload => {
          this.rangeData = this.setRangeData(payload, null)
        })
        .fetch()
    },
    setRangeData (arr = [], pid) {
      arr.forEach((item, index) => {
        item.title = item.name

        item['pid'] = pid
        if (item.pid) {
          item.key = pid + '|' + item.keyname + '-' + item.id
        } else {
          item.key = item.keyname + '-' + item.id
        }
        if (item.children && item.children.length) {
          this.setRangeData(item.children, item.key)
        }
      })
      return arr || []
    },
    setSelectRange (rangeCheckedData) {
      let arr = []
      arr = rangeCheckedData.map(item => {
        let key = ''
        let name = ''

        if (item.roleid && item.groupid && item.userid) {
          key = `roleid-${item.roleid}|groupid-${item.groupid}|userid-${item.userid}`
          name = item.truename
        } else if (item.roleid && item.groupid) {
          key = `roleid-${item.roleid}|groupid-${item.groupid}`
          name = item.groupname
        } else if (item.userid) {
          key = `userid-${item.userid}`
          name = item.truename
        } else if (item.roleid) {
          key = `roleid-${item.roleid}`
          name = item.rolename
        }
        return { key, name }
      })
      return arr
    },
    async handleEditRange (index, type) {
      this.editRangeIndex = index
      await this.getMembers(type)
      let { range = [] } = this.detail || {}
      this.selectRangeDatas = this.setSelectRange(range[index].data)
      this.$refs.rangeModal && this.$refs.rangeModal.toggleDialog(true)
    },
    /* 数据范围弹窗-点击确定 */
    changeRangeDatas (res) {
      this.selectRangeDatas = res
      let arr = this.selectRangeDatas.map(item => {
        let roleInfo = item.key.split('|')
        let obj = {}
        roleInfo.forEach(one => {
          let arr = one.split('-')
          obj[arr[0]] = arr[1]
        })
        if (obj.userid) {
          obj.truename = item.name
        } else if (obj.groupid) {
          obj.groupname = item.name
        } else if (obj.roleid) {
          obj.rolename = item.name
        }

        return obj
      })

      this.detail.range[this.editRangeIndex].data = arr
      this.form.setFieldsValue({
        [`group.${this.editRangeIndex}.range`]: arr
      })

      // 清数据
      const { type: rangeType } = this.detail.range[this.editRangeIndex]
      const { type: targetType } = this.detail.target[this.editRangeIndex]
      if (targetType === 2) { // 目标类型是按目标时
        if (rangeType === 'dev' || rangeType === 'rec') {
          // 清空总体目标和分解目标
          this.detail.target[this.editRangeIndex].base = ''
          this.detail.target[this.editRangeIndex].target = ''
          this.detail.target[this.editRangeIndex].challenge = ''
          this.detail.target[this.editRangeIndex].data.info = []
          this.form.setFieldsValue({
            [`group.${this.editRangeIndex}.total.base`]: '',
            [`group.${this.editRangeIndex}.total.target`]: '',
            [`group.${this.editRangeIndex}.total.challenge`]: ''
          })
        } else if (rangeType === 'follow') {
          // 清空目标值
          this.detail.target[this.editRangeIndex].data.total = ''
          this.form.setFieldsValue({
            [`group.${this.editRangeIndex}.follow.total`]: ''
          })
        }
      }
    },
    /* 校验目标等值 */
    checkInputNumber (rule, value, callback) {
      const { field = '' } = rule || {}
      let fieldvalue = value && value.toString().trim()
      // 总体目标和分解目标的目标值为空验证
      // 等级：总体(条)值为空验证
      // 销售目标值为空验证
      if ((field.indexOf('.target') !== -1 || field.indexOf('.total.level') !== -1 || field.indexOf('.follow.total') !== -1) && fieldvalue === '') {
        callback(this.$t('message["751"]'))
      }

      if (field.indexOf('.total.') !== -1) { // 总体目标: 基础值/目标值/挑战值 比较大小
        const index = field.split('.')[1]
        let { base, target, challenge } = this.detail.target[index]
        this.compareTargetNumber({ base, target, challenge }, field, callback)
      } else if (field.indexOf('.child.') !== -1) { // 分解目标: 基础值/目标值/挑战值 比较大小
        const index = field.split('.')[1]
        const k = field.split('.')[3]
        let { base, target, challenge } = this.detail.target[index].data.info[k]
        this.compareTargetNumber({ base, target, challenge }, field, callback)
      }
      callback()
    },
    compareTargetNumber (data, field, callback) {
      let { base, target, challenge } = data || {}
      if (field.indexOf('base') !== -1 && base !== '' && target !== '' && Number(base) > Number(target)) {
        // 基础值不能大于目标值
        const msg = this.$t('message["1954"]')
        callback(msg)
      }
      if (field.indexOf('target') !== -1 && base !== '' && target !== '' && (Number(base) > Number(target))) {
        // 目标值不能小于基础值
        const msg = this.$t('message["1955"]')
        callback(msg)
      }
      if (field.indexOf('target') !== -1 && challenge !== '' && target !== '' && (Number(challenge) < Number(target))) {
        // 目标值不能大于挑战值
        const msg = this.$t('message["1956"]')
        callback(msg)
      }
      if (field.indexOf('target') !== -1 && base !== '' && target !== '' && challenge !== '' && (Number(base) > Number(target) || Number(challenge) < Number(target))) {
        // 目标值不能小于基础值、目标值不能大于挑战值
        const msg = this.$t('message["1957"]')
        callback(msg)
      }
      if (field.indexOf('challenge') !== -1 && Number(base) !== '' && challenge !== '' && Number(target) > Number(challenge)) {
        // 挑战值不能小于目标值
        const msg = this.$t('message["1958"]')
        callback(msg)
      }
    },
    handleChangeNumber (val, index, name) {
      if (name === 'follow') {
        if (this.$toType(this.detail.target[index].data) === 'array') {
          this.detail.target[index].data = {}
        }
        this.detail.target[index].data.total = val
      } else {
        this.detail.target[index][name] = val
      }
      this.$forceUpdate()
    },
    handleBlurTarget (e, index, name) {
      let val = e.target.value
      if (name === 'follow') {
        if (this.$toType(this.detail.target[index].data) === 'array') {
          this.detail.target[index].data = {}
        }
        this.detail.target[index].data.total = val
        this.form.setFieldsValue({
          [`group.${index}.follow.total`]: val
        })
        this.form.validateFields([`group.${index}.follow.total`])
      } else {
        this.detail.target[index][name] = val
        this.form.setFieldsValue({
          [`group.${index}.total.base`]: this.detail.target[index].base,
          [`group.${index}.total.target`]: this.detail.target[index].target,
          [`group.${index}.total.challenge`]: this.detail.target[index].challenge
        })
        this.form.validateFields([`group.${index}.total.base`, `group.${index}.total.target`, `group.${index}.total.challenge`])
      }
    },
    handleChangeChildNumber (val, index, k, name) {
      this.detail.target[index].data.info[k][name] = val
      this.$forceUpdate()
    },
    handleBlurTargetChild (e, index, k, name) {
      let val = e.target.value
      this.detail.target[index].data.info[k][name] = val

      this.form.setFieldsValue({
        [`group.${index}.child.${k}.base`]: this.detail.target[index].data.info[k].base,
        [`group.${index}.child.${k}.target`]: this.detail.target[index].data.info[k].target,
        [`group.${index}.child.${k}.challenge`]: this.detail.target[index].data.info[k].challenge
      })
      this.form.validateFields([`group.${index}.child.${k}.base`, `group.${index}.child.${k}.target`, `group.${index}.child.${k}.challenge`])
    },
    async handleVisibleUser (val, index, k) {
      let _this = this
      if (val) {
        let chain = await this.getAllUselList({
          type: _this.detail.range[index].type,
          data: _this.detail.range[index].data
        })
        chain.onSuccess((payload = []) => {
          let options = this.resetUserOptions(index, payload)
          _this.$set(_this.detail.target[index].data, 'userOptions', options)
        })
      }
    },
    resetUserOptions (index, list = []) {
      // 获取当前团队选择过的分解目标人员
      let { target = [] } = this.detail || {}
      let currItme = target[index] && target[index].data && target[index].data.info
      if (!currItme) return []

      let currSelectedUserids = []
      for (let one of currItme) {
        if (one.userid) {
          currSelectedUserids.push(one.userid)
        }
      }

      // 分解目标人员过滤掉选择过的人员
      for (let len = list.length, i = len - 1; i >= 0; i--) {
        let item = list[i]
        for (let id of currSelectedUserids) {
          if (item.id === Number(id)) {
            list.splice(i, 1)
          }
        }
      }

      return list
    },
    handleChangeUser (val, index, k) {
      this.detail.target[index].data.info[k].userid = val
      this.form.setFieldsValue({
        [`group.${index}.userid.${k}`]: val
      })
    },
    /* 目标-月/年/周 */
    onChangeTarget (e, index) {
      let val = e.target.value
      this.detail.target[index].unit = val

      const { type: rangeType } = this.detail.range[index]
      const { type: targetType } = this.detail.target[index]
      if (rangeType === 'follow') { // 清空销售目标值
        this.detail.target[index].data.total = ''
        this.$nextTick(() => {
          this.form.setFieldsValue({
            [`group.${index}.follow.total`]: ''
          })
        })
      } else {
        if (targetType === 1) { // 清空信息分级的值
          const { levels = [] } = this.detail.target[index].data || {}
          this.detail.target[index].data.levels = levels.map(level => {
            level.value = ''
            return level
          })
          this.detail.target[index].data.total = ''
          this.$nextTick(() => {
            this.form.setFieldsValue({
              [`group.${index}.total.level`]: ''
            })
          })
        } else if (targetType === 2) { // 清空总体目标和分解目标
          this.detail.target[index].base = ''
          this.detail.target[index].target = ''
          this.detail.target[index].challenge = ''
          this.detail.target[index].data.info = []
          this.form.setFieldsValue({
            [`group.${index}.total.base`]: '',
            [`group.${index}.total.target`]: '',
            [`group.${index}.total.challenge`]: ''
          })
        }
      }
    },
    /* 目标类型-等级/目标 */
    onChangeTargetType (e, index) {
      let val = e.target.value
      this.detail.target[index].type = val

      let { level: levelMap = {} } = this.allConfig || {}
      let levelInfo = {}
      let levels = []
      for (let id in levelMap) {
        levelInfo[id] = ''
        let obj = {
          ...levelMap[id],
          value: 0
        }
        for (let levelId in levelInfo) {
          if (id === levelId) {
            obj.value = levelInfo[levelId]
          }
        }
        levels.push(obj)
      }
      this.detail.target[index].data = {}
      if (val === 1) {
        delete this.detail.target[index].base
        delete this.detail.target[index].target
        delete this.detail.target[index].challenge
        delete this.detail.target[index].total

        this.detail.target[index].data.info = levelInfo
        this.detail.target[index].data.levels = levels
        this.detail.target[index].data.total = ''
      } else if (val === 2) {
        delete this.detail.target[index].data.total
        delete this.detail.target[index].total

        this.detail.target[index].data.info = []
        this.detail.target[index].base = ''
        this.detail.target[index].target = ''
        this.detail.target[index].challenge = ''
      }
    },
    handleChangeTotal (val, index) {
      if (this.detail.target[index] && this.detail.target[index].data) {
        this.detail.target[index].data.total = val
      }
      this.$forceUpdate()
    },
    handleInputLevel (val, index, i) {
      if (this.detail.target[index] && this.detail.target[index].levels) {
        this.detail.target[index].levels[i].value = val
      }
      this.$forceUpdate()
    },
    formatterValue (value) {
      if (typeof value === 'string') {
        return `${value.replace(/\D/g, '')}`
      }
      return value === '' ? 0 : value
    },
    handleAddTargetChild (index) {
      this.detail.target[index].data.info.push({
        base: '',
        challenge: '',
        target: '',
        truename: '',
        userid: undefined
      })
      this.$forceUpdate()
    },
    handleDeleteTargetChild (index, k) {
      this.detail.target[index].data.info.splice(k, 1)
      this.$forceUpdate()
    },
    /* setDisabledBtn (detail = {}) {
      // 预览按钮状态
      if (detail.name && detail.type) {
        this.isBtnDisable = false
      }
    }, */
    setSaveParams () {
      let { detail } = this
      let { name, type, range = [], target = [] } = detail || {}

      let copyTarget = cloneDeep(target)
      for (let index in copyTarget) {
        const targetItem = copyTarget[index]
        const { type: targetType } = targetItem || {}
        const rangeItem = range[index]
        const { type: rangeType } = rangeItem || {}

        /* if (targetItem.unit === 0) { // 目标不设置
          targetItem.data = {}
        } */
        if (targetType === 1 && rangeType !== 'follow') {
          let { levels = [] } = targetItem.data || {}
          targetItem.data.info = targetItem.data.info || {}
          for (let i = 0; i < levels.length; i++) {
            let { id, value } = levels[i]
            targetItem.data.info[id] = value
          }
          delete targetItem.data.levels
          targetItem.data.total = !targetItem.data.total ? 0 : targetItem.data.total
        }
        if (targetType === 2 && rangeType !== 'follow') {
          delete targetItem.data.userOptions
        }
        if (rangeType === 'follow') {
          targetItem.type = targetItem.type || 2
        }
      }

      let params = {
        name, type, range, target: copyTarget
      }

      if (this.id) {
        params.id = this.id
      }

      return params
    },
    handleSubmit () {
      this.form.validateFields(async (err, data) => {
        this.isBtnDisable = !!err
        if (!err) {
          let params = this.setSaveParams()
          let chain = await this.setConfig(params)
          chain.onSuccess(res => {
            const { code = '', id } = res
            this.showCodeModal = true
            this.previewCode = code
            if (this.$route.name === 'configAddTv') {
              this.$router.push({
                name: 'configTvDetail',
                params: {
                  id
                }
              })
            }
          })
        }
      })
    },
    openWindow (url) {
      var link = document.createElement('a')
      link.target = '_blank'
      link.href = url
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    async handlePrivew () {
      this.form.validateFields(async (err, data) => {
        this.isBtnDisable = !!err

        if (!this.isBtnDisable) {
          let params = this.setSaveParams()
          params.status = 2
          let chain = await this.setConfig(params)
          chain.onSuccess((res = {}) => {
            const { code = '' } = res
            let { port, protocol, hostname } = location
            const isDingding = hostname.indexOf('dtwork') > -1
            let env
            if (port === '93') {
              env = '.dev'
              port = ':' + port
            } else if (port === '89') {
              env = '.dev'
              port = ':' + port
            } else {
              env = ''
            }

            this.previewHref = protocol + '//tv' + env + '.westartrack.com' + port + '/?code=' + code
            if (isDingding) {
              this.previewHref = protocol + '//tv' + env + '.westartrack.com' + port + '/?dingtalk=1&code=' + code
            }

            this.openWindow(this.previewHref)
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.tv-detail-page {
  min-width: 1040px;
}
h1.title {
  margin-top: 0;
}
::v-deep .ant-form-item-label {
  float: left;
  width: 134px;
  padding-right: 16px;
  label {
    color: #666;
  }
}
::v-deep .ant-form-item-children {
  display: inline-block;
}
::v-deep .ant-form-item-label + .ant-form-item-control-wrapper {
  padding-left: 134px;
}
.ant-input, .ant-select {
  width: 320px;
}
.name-input {
  .num {
    position: absolute;
    top: 0;
    right: 0;
    padding-right: 12px;
    color: #D6D6D6;
    font-size: 12px;
  }
}
.group-box {
  h3.title {
    height: 48px;
    line-height: 48px;
    margin-bottom: 24px;
    font-size: 18px;
    font-weight: bold;
    border-top: solid 1px #ebebeb;
  }
}
.overall-goals-item {
  .ant-input-number {
    width: 126px;
  }
}
.target-radio ::v-deep {
  .ant-radio-wrapper {
    margin-right: 16px;
  }
}

.level-box {
  display: table;
  padding-left: 134px;
  li {
    width: 112px;
    display: table-cell;
    float: none;
  }
  .tit {
    width: 100%;
    height: 48px;
    line-height: 48px;
    margin-bottom: 16px;
    padding-left: 16px;
    white-space: nowrap;
    background-color: #F5F6F7;
    border-radius: 4px 0px 0px 0px;
  }
  span.tit {
    display: inline-block;
  }
}
.target-input::v-deep {
  position: relative;
  .ant-input-number {
    width: 126px;
    padding-right: 20px;
  }
  .txt {
    position: absolute;
    top: 0;
    left: 105px;
    color: #D6D6D6;
  }
}
.isChinese .target-input::v-deep {
  .ant-form-item-label {
    width: 56px;
  }
  .ant-form-item-label + .ant-form-item-control-wrapper {
    padding-left: 56px;
  }
}
.follow-target-input {
  .ant-input-number {
    width: 126px;
    padding-right: 20px;
  }
  .txt {
    position: absolute;
    top: 0;
    left: 100px;
    color: #D6D6D6;
  }
}
.target-child-wrap {
  .ant-form-item-label {
    margin-top: 8px;
  }
}
.target-child {
  display: table;
  width: 100%;
  table-layout: fixed;
  margin-bottom: 16px;
  li {
    width: 112px;
    display: table-cell;
    float: none;
    width: 192px;
    &:nth-child(1) {
      width: 256px;
    }
    &:last-child(1) {
      width: 76px;
    }
  }
  .ant-form-item {
    margin-bottom: 0;
  }
  .tit {
    height: 48px;
    line-height: 48px;
    margin-bottom: 16px;
    padding-left: 16px;
    background-color: #F5F6F7;
    border-radius: 4px 0px 0px 0px;
  }
  span.tit {
    display: inline-block;
  }
  .ant-input, .ant-select {
    width: 100%;
  }
}
.footer-wrap {
  height: 64px;
}
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 64px;;
  z-index: 999;
  margin-left: -40px;
  padding: 16px 80px;
  background-color: #fff;
  border-top: solid 1px $gray4;
  transition: bottom 0.5s linear;
}
.isEnglish {
  ::v-deep .ant-form-item-label {
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
